import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { I18n } from '../helpers/i18n'; // Ensure you've imported toast

const PrivateRouteSenior = ({ component: Component, commonProps, ...rest }) => {
    const userData = localStorage.getItem('user-info');
    const user = userData ? JSON.parse(userData) : null;

    return (
        <Route
            {...rest}
            render={(props) => {
                if (user && user.type === "senior") {
                    return <Component {...commonProps} {...props} />;
                } else {
                    // Show toast message before redirecting
                    toast.info(I18n.t('need_senior_account'), {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        className: 'toast-info-container',
                    });
                    return redirectToLogin(props);
                }
            }}
        />
    );
};

function redirectToLogin(props) {
  const historyUrl = window.location.href.replace(window.location.origin, "");
  sessionStorage.setItem('previousUrl', historyUrl);
  return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
}

export default PrivateRouteSenior;
